import React, { useEffect, useState } from 'react'
import InternalUsersOfClient from '../../../components/AdminReports/AssignedUsersOfClient/InternalUsersOfClient';
import ExternalUsersOfClient from '../../../components/AdminReports/AssignedUsersOfClient/ExternalUsersOfClient';
import { CommonHeader } from '../../../components/commons';


interface TabsType {
    name: string;
    label: string;
};

type AppProps = {
    history: any;
}

const AssignedUsersOfClient = ({ history }: AppProps) => {

    const tabs: TabsType[] = [
        {
            name: 'Internal User',
            label: 'Internal_User'
        },
        {
            name: 'External User',
            label: 'External_User'
        },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].label);
    const [activeComponent, setActiveComponent] = useState<any>()

    const handleTabChange = (tabs: string) => {
        setActiveTab(tabs);
    };


    useEffect(() => {
        let locationTab = history &&
            history?.location &&
            history?.location?.state && history?.location?.state ? history?.location?.state : 0;
        if (locationTab) {
            setActiveTab(locationTab);
            if (locationTab === "Internal_User") {
                setActiveComponent(
                    <InternalUsersOfClient
                    history={history}
                    activeTab={activeTab}
                     
                    />
                )
            }
            else if (locationTab === "External_User") {

                setActiveComponent(
                    <ExternalUsersOfClient
                    history={history}
                    activeTab={activeTab}
                    />
                )
            }
        } else {

            if (activeTab === "Internal_User") {
                setActiveComponent(
                    <InternalUsersOfClient
                    history={history}
                    activeTab={activeTab}        
                    />
                )
            }
            else if (activeTab === "External_User") {
                setActiveComponent(
                    <ExternalUsersOfClient
                    history={history}
                    activeTab={activeTab}
                />
                )
            }
        
        }
        if (activeTab === "Internal_User") {
            setActiveComponent(
                <InternalUsersOfClient
                    history={history}
                    activeTab={activeTab}

                    />
            )
        }
        else if (activeTab === "External_User") {
            setActiveComponent(
                <ExternalUsersOfClient
                history={history}
                activeTab={activeTab}

            />
            )
        }
    }, [activeTab])

    const renderTabs = () => {

        let finalTab = tabs?.map((tab: TabsType) => {
            return (
                <div
                    className={"tab-style mr-4"}
                    key={tab.label}
                    onClick={() => { handleTabChange(tab.label) }}
                >

                    <div style={{ padding: "12px 5px 12px 5px", color: activeTab === tab.label ? "#dd4433" : "" }} className={`tab-header ${activeTab === tab.label ? "active" : ""}`}>{tab.name}

                    </div>
                    <div
                        className={`${activeTab === tab.label
                            ? "active-tab-bottom-border"
                            : "not-active-tab-bottom-border"
                            }`}
                    ></div>
                </div>
            );
        });

        return finalTab;
    }

    return (
        <>
            <div className='row'>
                <div className='col-md-6'>
                <CommonHeader title='Assigned Users of Client' />

                </div>
            </div>

            <div className="col-md-12 mt-4">
                <div style={{ background: "#d8dee4", borderRadius: "5px 5px 0 0", padding: "0px 15px" }}>
                    <div className='d-flex align-items-center'>{renderTabs()}</div>
                </div>
            </div>

            <div className='col-md-12'>
                <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }} >
                    {activeComponent}
                </div>
            </div>
        </>
    )
}


export default AssignedUsersOfClient;

